/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { integrationsGroupedBySourceSystemSchema } from './integrationsGroupedBySourceSystemSchema';

export const integrationsBySourceResponseSchema = z.object({
  get integrationsBySource() {
    return z.array(integrationsGroupedBySourceSystemSchema);
  },
});
